import getters from './getters';
import mutations from './mutations';

const state = {
  showRoom: {
    filtersHasChanged: false,
    filtersHasReseted: false,
    tabActive: '',
    filters: {
      campaignType: {
        value: ['TODOS'],
        dataType: 'Array',
        query: 'campaignType[eqs]=#values#'
      },
      modality: {
        value: ['TODOS'],
        dataType: 'Array',
        query: 'modality[eqs]=#values#'
      },
      flow: {
        value: ['TODOS'],
        dataType: 'Array',
        query: 'flow[eqs]=#values#'
      },
      carFuelType: {
        value: [],
        dataType: 'Array',
        query: 'car.fuelType[in]=#values#'
      },
      carPlateNumber: {
        value: '',
        dataType: 'String',
        query: 'car.plateNumber[like]=#value#'
      },
      carBrand: {
        value: '',
        dataType: 'String',
        query: 'car.brand[eqs]=#value#'
      },
      carModel: {
        value: '',
        dataType: 'String',
        query: 'car.model[eqs]=#value#'
      },
      carBodyStyle: {
        value: [],
        dataType: 'Array',
        query: 'car.bodyStyle[in]=#values#'
      },
      quoteIdQuote: {
        value: '',
        dataType: 'String',
        query: 'quote.idQuote[like]=#value#'
      },
      quoteTimeLimit: {
        value: [],
        dataType: 'Array',
        query: 'quote.timeLimit[in]=#values#'
      },
      carCO2Emission: {
        value: [],
        dataType: 'Range',
        query: 'car.cO2Emission[gte]=#value1#&car.cO2Emission[lte]=#value2#'
      },
      quoteYearKms: {
        value: [],
        dataType: 'Array',
        query: 'quote.yearKms[in]=#values#'
      },
      quotePrice: {
        value: [],
        dataType: 'Range',
        query: 'quote.price[gte]=#value1#&quote.price[lte]=#value2#'
      },
      deliveryProvinceCode: {
        value: [],
        dataType: 'Array',
        query: 'deliveryProvinceCode[in]=#values#'
      },
      campaignFactory: {
        value: '',
        dataType: 'String',
        query: 'campaignFactory[eqs]=#value#'
      }
    },
    pagination: {
      perPage: 25,
      sortBy: null,
      sortDesc: true,
      currentPage: 1
    }
  },
  operationsListB2C: {
    filtersHasChanged: false,
    filtersHasReseted: false,
    filters: {
      carPlateNumberB2C: {
        value: '',
        dataType: 'String',
        query: 'platenumber[eqs]=#value#'
      },
      idOperationB2C: {
        value: '',
        dataType: 'String',
        query: 'operationId[eqs]=#value#'
      },
      idOfferMotherB2C: {
        value: '',
        dataType: 'String',
        query: 'ofertId[eqs]=#value#'
      },
      phoneB2C: {
        value: '',
        dataType: 'String',
        query: 'phone[eqs]=#value#'
      },
      dniB2C: {
        value: '',
        dataType: 'String',
        query: 'dni[eqs]=#value#'
      },
      clienteNameB2C: {
        value: '',
        dataType: 'String',
        query: 'clientname[like]=#value#'
      },
      referenceB2C: {
        value: '',
        dataType: 'String',
        query: 'pedido[like]=#value#'
      }
    },
    pagination: {
      perPage: 25,
      sortBy: null,
      sortDesc: true,
      currentPage: 1
    }
  },
  operationsListB2B: {
    filtersHasChanged: false,
    filtersHasReseted: false,
    filters: {
      carPlateNumberB2B: {
        value: '',
        dataType: 'String',
        query: 'platenumber[eqs]=#value#'
      },
      idOperationB2B: {
        value: '',
        dataType: 'String',
        query: 'operationId[eqs]=#value#'
      },
      idOfferMotherB2B: {
        value: '',
        dataType: 'String',
        query: 'ofertId[eqs]=#value#'
      },
      phoneB2B: {
        value: '',
        dataType: 'String',
        query: 'phone[eqs]=#value#'
      },
      dniB2B: {
        value: '',
        dataType: 'String',
        query: 'dni[eqs]=#value#'
      },
      clienteNameB2B: {
        value: '',
        dataType: 'String',
        query: 'clientname[like]=#value#'
      },
      referenceB2B: {
        value: '',
        dataType: 'String',
        query: 'pedido[like]=#value#'
      }
    },
    pagination: {
      perPage: 25,
      sortBy: null,
      sortDesc: true,
      currentPage: 1
    }
  },
  expirationsList: {
    filtersHasChanged: false,
    filtersHasReseted: false,
    filters: {
      searchExpirationList: {
        value: '',
        dataType: 'String',
        query: 'search=#value#'
      }
    },
    pagination: {
      perPage: 25,
      sortBy: null,
      sortDesc: true,
      currentPage: 1
    }
  },
  campaigns: {
    filtersHasChanged: false,
    filtersHasReseted: true,
    filters: {
      carBrand: {
        value: '',
        dataType: 'String',
        query: 'car.brand[eqs]=#value#'
      },
      carModel: {
        value: '',
        dataType: 'String',
        query: 'car.model[eqs]=#value#'
      }
    },
    pagination: {
      perPage: 25,
      sortBy: null,
      sortDesc: true,
      currentPage: 1
    }
  },

  imagesBenchFilter: {
    tabActive: '',
    filtersHasChanged: false,
    filtersHasReseted: false,
    filters: {
      vehicleId: '',
      vehicleType: '',
      vehicleLocation: '',
      vehicleBrand: '',
      vehicleModel: '',
      vehicleVersion: '',
      vehicle: '',
      selectIdVehicle: ''
    }
  },
  commonFilters: {
    typeVehicle: 'TODOS',
    bodyStyle: null,
    rangePrice: ['<300', '>900'],
    filter: null,
    partner: null
  },

  automaticPublication: {
    filtersHasChanged: false,
    filtersHasReseted: false,
    filters: {},
    pagination: {
      perPage: 25,
      sortBy: null,
      sortDesc: true,
      currentPage: 1
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations
};
